import { Container } from "inversify";

import { DiEntity, DiEntityIdentifier } from "./types";
import { BaseService } from "@core/services/base";
import { HttpClientService } from "@core/services/http-client.service";
import { ConfigService } from "@core/services/config.service";
import { StorageService } from "@core/services/storage.service";
import { sharedAppServices } from "@shared/services";
import { DI_TOKENS } from "@shared/constants/di";
import { SettingsService } from "@shared/services/settings.service";
import { PlanService } from "@shared/services/plan.service";
import { TransactionService } from "@shared/services/transaction.service";
import { PopupService } from "@shared/services/popup.service";
import { UploadService } from "@shared/services/upload.service";
import { RestrictedUsernamesService } from "@shared/services/restricted-usernames.service";
import { StoreBannersService } from "@shared/services/store-banners.service";

const diContainer = new Container();

const entitiesConfig: Array<{ diToken: DiEntityIdentifier; entity: DiEntity }> =
  [
    { diToken: DI_TOKENS.baseService, entity: BaseService },
    { diToken: DI_TOKENS.httpClientService, entity: HttpClientService },
    { diToken: DI_TOKENS.configService, entity: ConfigService },
    { diToken: DI_TOKENS.storageService, entity: StorageService },
    { diToken: DI_TOKENS.settingsService, entity: SettingsService },
    { diToken: DI_TOKENS.plansService, entity: PlanService },
    { diToken: DI_TOKENS.transactionsService, entity: TransactionService },
    { diToken: DI_TOKENS.popupService, entity: PopupService },
    { diToken: DI_TOKENS.uploadService, entity: UploadService },
    {
      diToken: DI_TOKENS.restricedUsernamesService,
      entity: RestrictedUsernamesService,
    },
    { diToken: DI_TOKENS.storeBannersService, entity: StoreBannersService },
    ...sharedAppServices.map((x) => ({ diToken: x.diToken, entity: x.entity })),
  ];

entitiesConfig.forEach(({ diToken, entity }) => {
  diContainer.bind(diToken).to(entity).inSingletonScope();
});

export { diContainer };
